// Browser globals expected by Node-style libraries bundled into this app:
//   - dragula (via ng2-dragula -> crossvent) reads `global`
//   - aws-sdk and elasticsearch-browser read `global` and `process.env`
// This file must load BEFORE any module that touches these names, so it is
// referenced from `polyfills` in angular.json. (It previously lived at the
// top of src/polyfills.ts, which was removed when migrating to the Angular
// 15 polyfills-array format.)

(window as any).global = window;
(window as any).process = { env: { DEBUG: undefined } };
